/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { RouteConfig } from 'vue-router';

export default [
  {
    name: 'quiz',
    path: '/quiz',
    meta: {},
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: '404' },
    children: [
      {
        name: 'quiz_join',
        path: 'join',
        meta: { title: '加入' },
      },
      {
        name: 'quiz_rank',
        path: ':tid/tops',
        meta: { title: '排行' },
        component: () => import('@/views/quiz/rank.vue'),
      },
      {
        name: 'quiz_invite',
        path: ':tid/invite',
        meta: { title: '邀请' },
        component: () => import('@/views/quiz/invite.vue'),
      },
      {
        name: 'quiz_records',
        path: ':tid/:rid(\\d+)',
        meta: { title: '答题中' },
        component: () => import('@/views/quiz/records.vue'),
      },
      {
        name: 'quiz_topics',
        path: ':tid',
        meta: { title: '答题' },
        component: () => import('@/views/quiz/topics.vue'),
      },
    ],
  },
] as RouteConfig[];
